import type { DocumentNode } from 'graphql';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `Date` scalar type represents a date. The Date appears in a JSON
	 * response as an ISO8601 formatted string, without a time component.
	 */
	Date: { input: string; output: string };
	/**
	 * The `DateTime` scalar type represents a date and time in the UTC
	 * timezone. The DateTime appears in a JSON response as an ISO8601 formatted
	 * string, including UTC timezone ("Z"). The parsed date and time string will
	 * be converted to UTC if there is an offset.
	 */
	DateTime: { input: string; output: string };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values parsed by the `Decimal` library. The Decimal appears in a JSON
	 * response as a string to preserve precision.
	 */
	Decimal: { input: string; output: string };
	/**
	 * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
	 * character sequences. The Json type is most often used to represent a free-form
	 * human-readable json string.
	 */
	Json: { input: { [key: string]: any }; output: { [key: string]: any } };
	/**
	 * The `UUID7` scalar type represents UUID7 compliant string data, represented as UTF-8
	 * character sequences.
	 */
	UUID7: { input: string; output: string };
};

/** The action failed due to an unexpected reason. */
export type ActionFailed = {
	__typename?: 'ActionFailed';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

export type AddressAnalysis = {
	__typename?: 'AddressAnalysis';
	error?: Maybe<Scalars['String']['output']>;
	isInHighRiskLocation?: Maybe<Scalars['Boolean']['output']>;
	isInsideOfPrison?: Maybe<Scalars['Boolean']['output']>;
	isNearToPrison?: Maybe<Scalars['Boolean']['output']>;
	isOutsideOfTerritory?: Maybe<Scalars['Boolean']['output']>;
	validatedFullAddress?: Maybe<Scalars['String']['output']>;
};

export type AntifraudAnalysis = {
	__typename?: 'AntifraudAnalysis';
	type: AntifraudAnalysisType;
	v1Analysis?: Maybe<AntifraudAnalysisV1>;
	v2Analysis?: Maybe<AntifraudAnalysisV2>;
};

export enum AntifraudAnalysisType {
	V1 = 'V1',
	V2 = 'V2'
}

export type AntifraudAnalysisV1 = {
	__typename?: 'AntifraudAnalysisV1';
	address?: Maybe<AddressAnalysis>;
	curp?: Maybe<CurpAnalysis>;
	email?: Maybe<EmailAnalysis>;
	identityFraudScore?: Maybe<Scalars['Int']['output']>;
	ine?: Maybe<IneAnalysis>;
	ipAddress?: Maybe<IpAddressAnalysis>;
	label?: Maybe<Scalars['String']['output']>;
	location?: Maybe<AddressAnalysis>;
	locationAndAddressDistance?: Maybe<LocationAndAddressDistanceAnalysis>;
	officialIdCurp?: Maybe<CurpAnalysis>;
	officialIdFaceRecognition?: Maybe<FaceRecognitionAnalysis>;
	officialIdRfc?: Maybe<RfcAnalysis>;
	passport?: Maybe<PassportAnalysis>;
	pep?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
	phoneNumber?: Maybe<PhoneNumberAnalysis>;
	rfc?: Maybe<RfcAnalysis>;
	sanctions?: Maybe<Array<Maybe<Scalars['Json']['output']>>>;
	selfieAndOfficialIdMatch?: Maybe<Scalars['Boolean']['output']>;
	selfieFaceRecognition?: Maybe<FaceRecognitionAnalysis>;
	warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AntifraudAnalysisV2 = {
	__typename?: 'AntifraudAnalysisV2';
	rawData: Scalars['Json']['output'];
};

export type ApproveRegistryInput = {
	clientId: Scalars['UUID7']['input'];
	deliberation: Scalars['String']['input'];
};

export type ApproveRegistryPayload = {
	__typename?: 'ApproveRegistryPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type CompanyInformation = {
	__typename?: 'CompanyInformation';
	companyPhoneNumber?: Maybe<Scalars['String']['output']>;
	legalName?: Maybe<Scalars['String']['output']>;
	rfc?: Maybe<Scalars['String']['output']>;
	taxRegimeCode?: Maybe<TaxRegimeCode>;
};

export type CurpAnalysis = {
	__typename?: 'CurpAnalysis';
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['String']['output']>;
	error?: Maybe<Scalars['String']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	governmentName?: Maybe<Scalars['String']['output']>;
	isMexican?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type DatetimeRange = {
	from?: InputMaybe<Scalars['DateTime']['input']>;
	to?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DownloadRegistryDocumentsInput = {
	clientId: Scalars['UUID7']['input'];
};

export type DownloadRegistryDocumentsPayload = {
	__typename?: 'DownloadRegistryDocumentsPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	result?: Maybe<RegistryDocuments>;
	successful: Scalars['Boolean']['output'];
};

export type EmailAnalysis = {
	__typename?: 'EmailAnalysis';
	deliverability?: Maybe<Scalars['String']['output']>;
	fraudScore?: Maybe<Scalars['Int']['output']>;
	hasRecentAbuseInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	isDisposable?: Maybe<Scalars['Boolean']['output']>;
	isFrequentComplainer?: Maybe<Scalars['Boolean']['output']>;
	isLeaked?: Maybe<Scalars['Boolean']['output']>;
	isSpamHoneypot?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	sanitizedEmail?: Maybe<Scalars['String']['output']>;
	spamTrapScore?: Maybe<Scalars['String']['output']>;
};

export type FaceRecognitionAnalysis = {
	__typename?: 'FaceRecognitionAnalysis';
	companiesSeen?: Maybe<Scalars['Int']['output']>;
	confidenceScore?: Maybe<Scalars['Decimal']['output']>;
	gender?: Maybe<Scalars['String']['output']>;
	isMarkedAsFraudInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	lastSeenInTrullyNetwork?: Maybe<Scalars['String']['output']>;
	timesSeenLastMonthInTrullyNetwork?: Maybe<Scalars['Int']['output']>;
	warnings?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type IneAnalysis = {
	__typename?: 'IneAnalysis';
	curp?: Maybe<Scalars['String']['output']>;
	electoralKey?: Maybe<Scalars['String']['output']>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	validThru?: Maybe<Scalars['String']['output']>;
};

/** The action was not allowed for a given reason. */
export type InvalidAction = {
	__typename?: 'InvalidAction';
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Provided input is not valid. */
export type InvalidInput = {
	__typename?: 'InvalidInput';
	/** Validation context. */
	context: Array<Maybe<InvalidInputContext>>;
	/** Invalid input field's name. */
	field: Scalars['String']['output'];
	/** Translated friendly message. */
	message: Scalars['String']['output'];
};

/** Parameter taken into consideration for the validation. */
export type InvalidInputContext = {
	__typename?: 'InvalidInputContext';
	key: Scalars['String']['output'];
	value?: Maybe<Scalars['String']['output']>;
};

export type IpAddressAnalysis = {
	__typename?: 'IpAddressAnalysis';
	blacklistedCount?: Maybe<Scalars['Int']['output']>;
	isBlacklisted?: Maybe<Scalars['Boolean']['output']>;
	isTorConnection?: Maybe<Scalars['Boolean']['output']>;
	isVpnConnection?: Maybe<Scalars['Boolean']['output']>;
};

export type LegalRepresentative = {
	__typename?: 'LegalRepresentative';
	antifraudAnalysis?: Maybe<AntifraudAnalysis>;
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['Date']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	firstLastName?: Maybe<Scalars['String']['output']>;
	ipAddress?: Maybe<Scalars['String']['output']>;
	locationLatitude?: Maybe<Scalars['Decimal']['output']>;
	locationLongitude?: Maybe<Scalars['Decimal']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	rfc?: Maybe<Scalars['String']['output']>;
	secondLastName?: Maybe<Scalars['String']['output']>;
	stateOfBirth?: Maybe<MexState>;
};

export type LocationAndAddressDistanceAnalysis = {
	__typename?: 'LocationAndAddressDistanceAnalysis';
	level?: Maybe<Scalars['String']['output']>;
	observation?: Maybe<Scalars['String']['output']>;
};

/** Mexico's state in ISO 3166-1 alpha-3 format */
export enum MexState {
	AGU = 'AGU',
	BCN = 'BCN',
	BCS = 'BCS',
	CAM = 'CAM',
	CHH = 'CHH',
	CHP = 'CHP',
	CMX = 'CMX',
	COA = 'COA',
	COL = 'COL',
	DUR = 'DUR',
	GRO = 'GRO',
	GUA = 'GUA',
	HID = 'HID',
	JAL = 'JAL',
	MEX = 'MEX',
	MIC = 'MIC',
	MOR = 'MOR',
	NAY = 'NAY',
	NLE = 'NLE',
	OAX = 'OAX',
	PUE = 'PUE',
	QUE = 'QUE',
	ROO = 'ROO',
	SIN = 'SIN',
	SLP = 'SLP',
	SON = 'SON',
	TAB = 'TAB',
	TAM = 'TAM',
	TLA = 'TLA',
	VER = 'VER',
	YUC = 'YUC',
	ZAC = 'ZAC'
}

/** Common errors for any mutation. */
export type MutationError = ActionFailed | InvalidAction | InvalidInput;

export type Node = {
	/** The ID of the object. */
	id: Scalars['ID']['output'];
};

export enum OnboardingStatus {
	APPROVED = 'APPROVED',
	CORRECTIONS_REQUESTED = 'CORRECTIONS_REQUESTED',
	IN_PROCESS = 'IN_PROCESS',
	PENDING_REVIEW = 'PENDING_REVIEW',
	REJECTED = 'REJECTED'
}

export type PageInfo = {
	__typename?: 'PageInfo';
	/** When paginating forwards, the cursor to continue. */
	endCursor?: Maybe<Scalars['String']['output']>;
	/** When paginating forwards, are there more items? */
	hasNextPage: Scalars['Boolean']['output'];
	/** When paginating backwards, are there more items? */
	hasPreviousPage: Scalars['Boolean']['output'];
	/** When paginating backwards, the cursor to continue. */
	startCursor?: Maybe<Scalars['String']['output']>;
};

export type PassportAnalysis = {
	__typename?: 'PassportAnalysis';
	citizenship?: Maybe<Scalars['String']['output']>;
	curp?: Maybe<Scalars['String']['output']>;
	dateOfBirth?: Maybe<Scalars['String']['output']>;
	expirationDate?: Maybe<Scalars['String']['output']>;
	lastNames?: Maybe<Scalars['String']['output']>;
	names?: Maybe<Scalars['String']['output']>;
	passportNumber?: Maybe<Scalars['String']['output']>;
};

export type PhoneNumberAnalysis = {
	__typename?: 'PhoneNumberAnalysis';
	carrier?: Maybe<Scalars['String']['output']>;
	city?: Maybe<Scalars['String']['output']>;
	country?: Maybe<Scalars['String']['output']>;
	fraudScore?: Maybe<Scalars['Int']['output']>;
	hasFraudulentBehavior?: Maybe<Scalars['Boolean']['output']>;
	hasRecentAbuseInTrullyNetwork?: Maybe<Scalars['Boolean']['output']>;
	isActive?: Maybe<Scalars['Boolean']['output']>;
	isDigitalPhoneNumber?: Maybe<Scalars['Boolean']['output']>;
	isLeaked?: Maybe<Scalars['Boolean']['output']>;
	isSpammer?: Maybe<Scalars['Boolean']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	onWhatsapp?: Maybe<Scalars['Boolean']['output']>;
};

export type Registry = Node & {
	__typename?: 'Registry';
	clientId?: Maybe<Scalars['UUID7']['output']>;
	companyInformation?: Maybe<CompanyInformation>;
	deliberation?: Maybe<Scalars['String']['output']>;
	email?: Maybe<Scalars['String']['output']>;
	/** The ID of an object */
	id: Scalars['ID']['output'];
	legalRepresentative?: Maybe<LegalRepresentative>;
	onboardingStatus?: Maybe<OnboardingStatus>;
	phoneNumber?: Maybe<Scalars['String']['output']>;
	registryStatus?: Maybe<RegistryStatus>;
	startedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegistryConnection = {
	__typename?: 'RegistryConnection';
	count?: Maybe<Scalars['Int']['output']>;
	edges?: Maybe<Array<Maybe<RegistryEdge>>>;
	pageInfo: PageInfo;
};

export type RegistryConnectionCountArgs = {
	filter?: InputMaybe<RegistryFilter>;
};

export type RegistryDocuments = {
	__typename?: 'RegistryDocuments';
	legalRepresentativeIneBack?: Maybe<Scalars['String']['output']>;
	legalRepresentativeIneFront?: Maybe<Scalars['String']['output']>;
	legalRepresentativeSelfie?: Maybe<Scalars['String']['output']>;
	organizationalChart?: Maybe<Scalars['String']['output']>;
	shareholdersAndEquityHoldings?: Maybe<Scalars['String']['output']>;
	shareholdingStructure?: Maybe<Scalars['String']['output']>;
};

export type RegistryEdge = {
	__typename?: 'RegistryEdge';
	cursor?: Maybe<Scalars['String']['output']>;
	node?: Maybe<Registry>;
};

export type RegistryFilter = {
	onboardingStatus?: InputMaybe<Array<InputMaybe<OnboardingStatus>>>;
	searchTerm?: InputMaybe<Scalars['String']['input']>;
	startedAt?: InputMaybe<DatetimeRange>;
};

export type RegistrySort = {
	onboardingStatus?: InputMaybe<SortDirection>;
	startedAt?: InputMaybe<SortDirection>;
};

export enum RegistryStatus {
	APPROVED = 'APPROVED',
	COMPANY_DOCUMENTATION_REGISTERED = 'COMPANY_DOCUMENTATION_REGISTERED',
	COMPANY_INFORMATION_REGISTERED = 'COMPANY_INFORMATION_REGISTERED',
	COMPLETED = 'COMPLETED',
	CONTACT_INFORMATION_REGISTERED = 'CONTACT_INFORMATION_REGISTERED',
	LEGAL_REPRESENTATIVE_REGISTERED = 'LEGAL_REPRESENTATIVE_REGISTERED',
	REJECTED = 'REJECTED'
}

export type RejectRegistryInput = {
	clientId: Scalars['UUID7']['input'];
	deliberation: Scalars['String']['input'];
};

export type RejectRegistryPayload = {
	__typename?: 'RejectRegistryPayload';
	mutationErrors: Array<Maybe<MutationError>>;
	successful: Scalars['Boolean']['output'];
};

export type RfcAnalysis = {
	__typename?: 'RfcAnalysis';
	blacklistStatus?: Maybe<Scalars['String']['output']>;
	isValid?: Maybe<Scalars['Boolean']['output']>;
	observation?: Maybe<Scalars['String']['output']>;
	validatedRfc?: Maybe<Scalars['String']['output']>;
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	approveRegistry?: Maybe<ApproveRegistryPayload>;
	downloadRegistryDocuments?: Maybe<DownloadRegistryDocumentsPayload>;
	rejectRegistry?: Maybe<RejectRegistryPayload>;
};

export type RootMutationTypeApproveRegistryArgs = {
	input: ApproveRegistryInput;
};

export type RootMutationTypeDownloadRegistryDocumentsArgs = {
	input: DownloadRegistryDocumentsInput;
};

export type RootMutationTypeRejectRegistryArgs = {
	input: RejectRegistryInput;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	node?: Maybe<Node>;
	registries?: Maybe<RegistryConnection>;
};

export type RootQueryTypeNodeArgs = {
	id: Scalars['ID']['input'];
};

export type RootQueryTypeRegistriesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<RegistryFilter>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<RegistrySort>>>;
};

export enum SortDirection {
	/** Ascending */
	ASC = 'ASC',
	/** Descending */
	DESC = 'DESC'
}

export enum TaxRegimeCode {
	CODE_601 = 'CODE_601',
	CODE_603 = 'CODE_603',
	CODE_609 = 'CODE_609',
	CODE_620 = 'CODE_620',
	CODE_622 = 'CODE_622',
	CODE_623 = 'CODE_623',
	CODE_624 = 'CODE_624',
	CODE_626 = 'CODE_626',
	CODE_628 = 'CODE_628',
	CODE_629 = 'CODE_629',
	CODE_630 = 'CODE_630'
}

export type DownloadRegistryDocumentsMutationVariables = Exact<{
	input: DownloadRegistryDocumentsInput;
}>;

export type DownloadRegistryDocumentsMutation = {
	__typename?: 'RootMutationType';
	downloadRegistryDocuments?: {
		__typename?: 'DownloadRegistryDocumentsPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
		result?: {
			__typename?: 'RegistryDocuments';
			shareholdingStructure?: string | null;
			shareholdersAndEquityHoldings?: string | null;
			organizationalChart?: string | null;
			legalRepresentativeIneFront?: string | null;
			legalRepresentativeIneBack?: string | null;
			legalRepresentativeSelfie?: string | null;
		} | null;
	} | null;
};

export type RejectRegistryMutationVariables = Exact<{
	input: RejectRegistryInput;
}>;

export type RejectRegistryMutation = {
	__typename?: 'RootMutationType';
	rejectRegistry?: {
		__typename?: 'RejectRegistryPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type ApproveRegistryMutationVariables = Exact<{
	input: ApproveRegistryInput;
}>;

export type ApproveRegistryMutation = {
	__typename?: 'RootMutationType';
	approveRegistry?: {
		__typename?: 'ApproveRegistryPayload';
		successful: boolean;
		mutationErrors: Array<
			| { __typename: 'ActionFailed'; message: string }
			| { __typename: 'InvalidAction'; message: string }
			| {
					__typename: 'InvalidInput';
					message: string;
					field: string;
					context: Array<{
						__typename?: 'InvalidInputContext';
						key: string;
						value?: string | null;
					} | null>;
			  }
			| null
		>;
	} | null;
};

export type GetNodeQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetNodeQuery = {
	__typename?: 'RootQueryType';
	node?: {
		__typename?: 'Registry';
		clientId?: string | null;
		email?: string | null;
		phoneNumber?: string | null;
		registryStatus?: RegistryStatus | null;
		onboardingStatus?: OnboardingStatus | null;
		deliberation?: string | null;
		startedAt?: string | null;
		id: string;
		companyInformation?: {
			__typename?: 'CompanyInformation';
			legalName?: string | null;
			companyPhoneNumber?: string | null;
			rfc?: string | null;
			taxRegimeCode?: TaxRegimeCode | null;
		} | null;
		legalRepresentative?: {
			__typename?: 'LegalRepresentative';
			email?: string | null;
			ipAddress?: string | null;
			names?: string | null;
			firstLastName?: string | null;
			secondLastName?: string | null;
			dateOfBirth?: string | null;
			curp?: string | null;
			rfc?: string | null;
			locationLatitude?: string | null;
			locationLongitude?: string | null;
			stateOfBirth?: MexState | null;
			antifraudAnalysis?: {
				__typename?: 'AntifraudAnalysis';
				type: AntifraudAnalysisType;
				v1Analysis?: {
					__typename?: 'AntifraudAnalysisV1';
					label?: string | null;
					warnings?: Array<string | null> | null;
					identityFraudScore?: number | null;
					pep?: Array<{ [key: string]: any } | null> | null;
					sanctions?: Array<{ [key: string]: any } | null> | null;
					selfieAndOfficialIdMatch?: boolean | null;
					locationAndAddressDistance?: {
						__typename?: 'LocationAndAddressDistanceAnalysis';
						level?: string | null;
						observation?: string | null;
					} | null;
					address?: {
						__typename?: 'AddressAnalysis';
						validatedFullAddress?: string | null;
						isNearToPrison?: boolean | null;
						isOutsideOfTerritory?: boolean | null;
						isInsideOfPrison?: boolean | null;
						isInHighRiskLocation?: boolean | null;
						error?: string | null;
					} | null;
					location?: {
						__typename?: 'AddressAnalysis';
						validatedFullAddress?: string | null;
						isNearToPrison?: boolean | null;
						isOutsideOfTerritory?: boolean | null;
						isInsideOfPrison?: boolean | null;
						isInHighRiskLocation?: boolean | null;
						error?: string | null;
					} | null;
					rfc?: {
						__typename?: 'RfcAnalysis';
						blacklistStatus?: string | null;
						isValid?: boolean | null;
						observation?: string | null;
						validatedRfc?: string | null;
					} | null;
					officialIdRfc?: {
						__typename?: 'RfcAnalysis';
						blacklistStatus?: string | null;
						isValid?: boolean | null;
						observation?: string | null;
						validatedRfc?: string | null;
					} | null;
					curp?: {
						__typename?: 'CurpAnalysis';
						curp?: string | null;
						governmentName?: string | null;
						isValid?: boolean | null;
						dateOfBirth?: string | null;
						gender?: string | null;
						isMexican?: boolean | null;
						error?: string | null;
					} | null;
					officialIdCurp?: {
						__typename?: 'CurpAnalysis';
						curp?: string | null;
						governmentName?: string | null;
						isValid?: boolean | null;
						dateOfBirth?: string | null;
						gender?: string | null;
						isMexican?: boolean | null;
						error?: string | null;
					} | null;
					ine?: {
						__typename?: 'IneAnalysis';
						curp?: string | null;
						firstLastName?: string | null;
						secondLastName?: string | null;
						names?: string | null;
						validThru?: string | null;
						electoralKey?: string | null;
					} | null;
					passport?: {
						__typename?: 'PassportAnalysis';
						curp?: string | null;
						lastNames?: string | null;
						names?: string | null;
						dateOfBirth?: string | null;
						citizenship?: string | null;
						expirationDate?: string | null;
						passportNumber?: string | null;
					} | null;
					selfieFaceRecognition?: {
						__typename?: 'FaceRecognitionAnalysis';
						lastSeenInTrullyNetwork?: string | null;
						isMarkedAsFraudInTrullyNetwork?: boolean | null;
						timesSeenLastMonthInTrullyNetwork?: number | null;
						warnings?: Array<string | null> | null;
						companiesSeen?: number | null;
						gender?: string | null;
						confidenceScore?: string | null;
					} | null;
					officialIdFaceRecognition?: {
						__typename?: 'FaceRecognitionAnalysis';
						lastSeenInTrullyNetwork?: string | null;
						isMarkedAsFraudInTrullyNetwork?: boolean | null;
						timesSeenLastMonthInTrullyNetwork?: number | null;
						warnings?: Array<string | null> | null;
						companiesSeen?: number | null;
						gender?: string | null;
						confidenceScore?: string | null;
					} | null;
					ipAddress?: {
						__typename?: 'IpAddressAnalysis';
						isBlacklisted?: boolean | null;
						blacklistedCount?: number | null;
						isTorConnection?: boolean | null;
						isVpnConnection?: boolean | null;
					} | null;
					email?: {
						__typename?: 'EmailAnalysis';
						deliverability?: string | null;
						sanitizedEmail?: string | null;
						isValid?: boolean | null;
						isDisposable?: boolean | null;
						isLeaked?: boolean | null;
						isSpamHoneypot?: boolean | null;
						hasRecentAbuseInTrullyNetwork?: boolean | null;
						isFrequentComplainer?: boolean | null;
						spamTrapScore?: string | null;
						fraudScore?: number | null;
					} | null;
					phoneNumber?: {
						__typename?: 'PhoneNumberAnalysis';
						isValid?: boolean | null;
						isActive?: boolean | null;
						isDigitalPhoneNumber?: boolean | null;
						isSpammer?: boolean | null;
						isLeaked?: boolean | null;
						hasRecentAbuseInTrullyNetwork?: boolean | null;
						hasFraudulentBehavior?: boolean | null;
						carrier?: string | null;
						country?: string | null;
						city?: string | null;
						fraudScore?: number | null;
						onWhatsapp?: boolean | null;
					} | null;
				} | null;
				v2Analysis?: { __typename?: 'AntifraudAnalysisV2'; rawData: { [key: string]: any } } | null;
			} | null;
		} | null;
	} | null;
};

export type RegistriesQueryVariables = Exact<{
	after?: InputMaybe<Scalars['String']['input']>;
	first?: InputMaybe<Scalars['Int']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sorts?: InputMaybe<Array<InputMaybe<RegistrySort>> | InputMaybe<RegistrySort>>;
	filter?: InputMaybe<RegistryFilter>;
}>;

export type RegistriesQuery = {
	__typename?: 'RootQueryType';
	registries?: {
		__typename?: 'RegistryConnection';
		count?: number | null;
		pageInfo: {
			__typename?: 'PageInfo';
			hasPreviousPage: boolean;
			hasNextPage: boolean;
			startCursor?: string | null;
			endCursor?: string | null;
		};
		edges?: Array<{
			__typename?: 'RegistryEdge';
			cursor?: string | null;
			node?: {
				__typename?: 'Registry';
				id: string;
				clientId?: string | null;
				registryStatus?: RegistryStatus | null;
				onboardingStatus?: OnboardingStatus | null;
				phoneNumber?: string | null;
				email?: string | null;
				startedAt?: string | null;
				companyInformation?: {
					__typename?: 'CompanyInformation';
					legalName?: string | null;
				} | null;
				legalRepresentative?: {
					__typename?: 'LegalRepresentative';
					email?: string | null;
					names?: string | null;
					firstLastName?: string | null;
					secondLastName?: string | null;
				} | null;
			} | null;
		} | null> | null;
	} | null;
};

export const DownloadRegistryDocumentsDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'DownloadRegistryDocuments' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: {
							kind: 'NamedType',
							name: { kind: 'Name', value: 'DownloadRegistryDocumentsInput' }
						}
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'downloadRegistryDocuments' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'result' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'shareholdingStructure' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'shareholdersAndEquityHoldings' }
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'organizationalChart' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'legalRepresentativeIneFront' }
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'legalRepresentativeIneBack' }
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'legalRepresentativeSelfie' } }
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type DownloadRegistryDocumentsMutationFn = Apollo.MutationFunction<
	DownloadRegistryDocumentsMutation,
	DownloadRegistryDocumentsMutationVariables
>;

/**
 * __useDownloadRegistryDocumentsMutation__
 *
 * To run a mutation, you first call `useDownloadRegistryDocumentsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDownloadRegistryDocumentsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [downloadRegistryDocumentsMutation, { data, loading, error }] = useDownloadRegistryDocumentsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDownloadRegistryDocumentsMutation(
	baseOptions?: Apollo.MutationHookOptions<
		DownloadRegistryDocumentsMutation,
		DownloadRegistryDocumentsMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<
		DownloadRegistryDocumentsMutation,
		DownloadRegistryDocumentsMutationVariables
	>(DownloadRegistryDocumentsDocument, options);
}
export type DownloadRegistryDocumentsMutationHookResult = ReturnType<
	typeof useDownloadRegistryDocumentsMutation
>;
export type DownloadRegistryDocumentsMutationResult =
	Apollo.MutationResult<DownloadRegistryDocumentsMutation>;
export type DownloadRegistryDocumentsMutationOptions = Apollo.BaseMutationOptions<
	DownloadRegistryDocumentsMutation,
	DownloadRegistryDocumentsMutationVariables
>;
export const RejectRegistryDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'RejectRegistry' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'RejectRegistryInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'rejectRegistry' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type RejectRegistryMutationFn = Apollo.MutationFunction<
	RejectRegistryMutation,
	RejectRegistryMutationVariables
>;

/**
 * __useRejectRegistryMutation__
 *
 * To run a mutation, you first call `useRejectRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRejectRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [rejectRegistryMutation, { data, loading, error }] = useRejectRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRejectRegistryMutation(
	baseOptions?: Apollo.MutationHookOptions<RejectRegistryMutation, RejectRegistryMutationVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<RejectRegistryMutation, RejectRegistryMutationVariables>(
		RejectRegistryDocument,
		options
	);
}
export type RejectRegistryMutationHookResult = ReturnType<typeof useRejectRegistryMutation>;
export type RejectRegistryMutationResult = Apollo.MutationResult<RejectRegistryMutation>;
export type RejectRegistryMutationOptions = Apollo.BaseMutationOptions<
	RejectRegistryMutation,
	RejectRegistryMutationVariables
>;
export const ApproveRegistryDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'mutation',
			name: { kind: 'Name', value: 'ApproveRegistry' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ApproveRegistryInput' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'approveRegistry' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'input' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'successful' } },
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'mutationErrors' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: '__typename' } },
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'ActionFailed' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidAction' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [{ kind: 'Field', name: { kind: 'Name', value: 'message' } }]
												}
											},
											{
												kind: 'InlineFragment',
												typeCondition: {
													kind: 'NamedType',
													name: { kind: 'Name', value: 'InvalidInput' }
												},
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'message' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'field' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'context' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'key' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'value' } }
																]
															}
														}
													]
												}
											}
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;
export type ApproveRegistryMutationFn = Apollo.MutationFunction<
	ApproveRegistryMutation,
	ApproveRegistryMutationVariables
>;

/**
 * __useApproveRegistryMutation__
 *
 * To run a mutation, you first call `useApproveRegistryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveRegistryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveRegistryMutation, { data, loading, error }] = useApproveRegistryMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveRegistryMutation(
	baseOptions?: Apollo.MutationHookOptions<
		ApproveRegistryMutation,
		ApproveRegistryMutationVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useMutation<ApproveRegistryMutation, ApproveRegistryMutationVariables>(
		ApproveRegistryDocument,
		options
	);
}
export type ApproveRegistryMutationHookResult = ReturnType<typeof useApproveRegistryMutation>;
export type ApproveRegistryMutationResult = Apollo.MutationResult<ApproveRegistryMutation>;
export type ApproveRegistryMutationOptions = Apollo.BaseMutationOptions<
	ApproveRegistryMutation,
	ApproveRegistryMutationVariables
>;
export const GetNodeDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'GetNode' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
					type: {
						kind: 'NonNullType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } }
					}
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'node' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'id' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
								{
									kind: 'InlineFragment',
									typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Registry' } },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'registryStatus' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'deliberation' } },
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'companyInformation' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'legalName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'companyPhoneNumber' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'rfc' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'taxRegimeCode' } }
													]
												}
											},
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'legalRepresentative' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'ipAddress' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'dateOfBirth' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'curp' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'rfc' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'locationLatitude' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'locationLongitude' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'stateOfBirth' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'antifraudAnalysis' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'type' } },
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'v1Analysis' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{ kind: 'Field', name: { kind: 'Name', value: 'label' } },
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'warnings' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'identityFraudScore' }
																				},
																				{ kind: 'Field', name: { kind: 'Name', value: 'pep' } },
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'sanctions' }
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'selfieAndOfficialIdMatch' }
																				},
																				{
																					kind: 'Field',
																					name: {
																						kind: 'Name',
																						value: 'locationAndAddressDistance'
																					},
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'level' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'observation' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'address' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'validatedFullAddress'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isNearToPrison' }
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isOutsideOfTerritory'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isInsideOfPrison' }
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isInHighRiskLocation'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'error' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'location' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'validatedFullAddress'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isNearToPrison' }
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isOutsideOfTerritory'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isInsideOfPrison' }
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isInHighRiskLocation'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'error' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'rfc' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'blacklistStatus' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isValid' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'observation' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'validatedRfc' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'officialIdRfc' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'blacklistStatus' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isValid' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'observation' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'validatedRfc' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'curp' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'curp' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'governmentName' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isValid' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'dateOfBirth' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'gender' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isMexican' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'error' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'officialIdCurp' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'curp' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'governmentName' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isValid' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'dateOfBirth' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'gender' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isMexican' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'error' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'ine' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'curp' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'firstLastName' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'secondLastName' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'names' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'validThru' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'electoralKey' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'passport' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'curp' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'lastNames' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'names' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'dateOfBirth' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'citizenship' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'expirationDate' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'passportNumber' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'selfieFaceRecognition' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'lastSeenInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isMarkedAsFraudInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'timesSeenLastMonthInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'warnings' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'companiesSeen' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'gender' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'confidenceScore' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: {
																						kind: 'Name',
																						value: 'officialIdFaceRecognition'
																					},
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'lastSeenInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isMarkedAsFraudInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'timesSeenLastMonthInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'warnings' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'companiesSeen' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'gender' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'confidenceScore' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'ipAddress' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isBlacklisted' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'blacklistedCount' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isTorConnection' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isVpnConnection' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'email' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'deliverability' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'sanitizedEmail' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isValid' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isDisposable' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isLeaked' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isSpamHoneypot' }
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'hasRecentAbuseInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isFrequentComplainer'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'spamTrapScore' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'fraudScore' }
																							}
																						]
																					}
																				},
																				{
																					kind: 'Field',
																					name: { kind: 'Name', value: 'phoneNumber' },
																					selectionSet: {
																						kind: 'SelectionSet',
																						selections: [
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isValid' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isActive' }
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'isDigitalPhoneNumber'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isSpammer' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'isLeaked' }
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'hasRecentAbuseInTrullyNetwork'
																								}
																							},
																							{
																								kind: 'Field',
																								name: {
																									kind: 'Name',
																									value: 'hasFraudulentBehavior'
																								}
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'carrier' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'country' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'city' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'fraudScore' }
																							},
																							{
																								kind: 'Field',
																								name: { kind: 'Name', value: 'onWhatsapp' }
																							}
																						]
																					}
																				}
																			]
																		}
																	},
																	{
																		kind: 'Field',
																		name: { kind: 'Name', value: 'v2Analysis' },
																		selectionSet: {
																			kind: 'SelectionSet',
																			selections: [
																				{ kind: 'Field', name: { kind: 'Name', value: 'rawData' } }
																			]
																		}
																	}
																]
															}
														}
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } }
										]
									}
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useGetNodeQuery__
 *
 * To run a query within a React component, call `useGetNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNodeQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetNodeQuery(
	baseOptions: Apollo.QueryHookOptions<GetNodeQuery, GetNodeQueryVariables> &
		({ variables: GetNodeQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
}
export function useGetNodeLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
}
export function useGetNodeSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetNodeQuery, GetNodeQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetNodeQuery, GetNodeQueryVariables>(GetNodeDocument, options);
}
export type GetNodeQueryHookResult = ReturnType<typeof useGetNodeQuery>;
export type GetNodeLazyQueryHookResult = ReturnType<typeof useGetNodeLazyQuery>;
export type GetNodeSuspenseQueryHookResult = ReturnType<typeof useGetNodeSuspenseQuery>;
export type GetNodeQueryResult = Apollo.QueryResult<GetNodeQuery, GetNodeQueryVariables>;
export function refetchGetNodeQuery(variables: GetNodeQueryVariables) {
	return { query: GetNodeDocument, variables: variables };
}
export const RegistriesDocument = {
	kind: 'Document',
	definitions: [
		{
			kind: 'OperationDefinition',
			operation: 'query',
			name: { kind: 'Name', value: 'Registries' },
			variableDefinitions: [
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'after' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'first' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'before' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'last' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'Int' } }
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } },
					type: {
						kind: 'ListType',
						type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistrySort' } }
					}
				},
				{
					kind: 'VariableDefinition',
					variable: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } },
					type: { kind: 'NamedType', name: { kind: 'Name', value: 'RegistryFilter' } }
				}
			],
			selectionSet: {
				kind: 'SelectionSet',
				selections: [
					{
						kind: 'Field',
						name: { kind: 'Name', value: 'registries' },
						arguments: [
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'after' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'after' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'first' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'first' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'before' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'before' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'last' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'last' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'sorts' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'sorts' } }
							},
							{
								kind: 'Argument',
								name: { kind: 'Name', value: 'filter' },
								value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
							}
						],
						selectionSet: {
							kind: 'SelectionSet',
							selections: [
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'pageInfo' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{ kind: 'Field', name: { kind: 'Name', value: 'hasPreviousPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'hasNextPage' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'startCursor' } },
											{ kind: 'Field', name: { kind: 'Name', value: 'endCursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'edges' },
									selectionSet: {
										kind: 'SelectionSet',
										selections: [
											{
												kind: 'Field',
												name: { kind: 'Name', value: 'node' },
												selectionSet: {
													kind: 'SelectionSet',
													selections: [
														{ kind: 'Field', name: { kind: 'Name', value: 'id' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'clientId' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'registryStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'onboardingStatus' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'phoneNumber' } },
														{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'companyInformation' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'legalName' } }
																]
															}
														},
														{
															kind: 'Field',
															name: { kind: 'Name', value: 'legalRepresentative' },
															selectionSet: {
																kind: 'SelectionSet',
																selections: [
																	{ kind: 'Field', name: { kind: 'Name', value: 'email' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'names' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'firstLastName' } },
																	{ kind: 'Field', name: { kind: 'Name', value: 'secondLastName' } }
																]
															}
														},
														{ kind: 'Field', name: { kind: 'Name', value: 'startedAt' } }
													]
												}
											},
											{ kind: 'Field', name: { kind: 'Name', value: 'cursor' } }
										]
									}
								},
								{
									kind: 'Field',
									name: { kind: 'Name', value: 'count' },
									arguments: [
										{
											kind: 'Argument',
											name: { kind: 'Name', value: 'filter' },
											value: { kind: 'Variable', name: { kind: 'Name', value: 'filter' } }
										}
									]
								}
							]
						}
					}
				]
			}
		}
	]
} as unknown as DocumentNode;

/**
 * __useRegistriesQuery__
 *
 * To run a query within a React component, call `useRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRegistriesQuery({
 *   variables: {
 *      after: // value for 'after'
 *      first: // value for 'first'
 *      before: // value for 'before'
 *      last: // value for 'last'
 *      sorts: // value for 'sorts'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useRegistriesQuery(
	baseOptions?: Apollo.QueryHookOptions<RegistriesQuery, RegistriesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<RegistriesQuery, RegistriesQueryVariables>(RegistriesDocument, options);
}
export function useRegistriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<RegistriesQuery, RegistriesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<RegistriesQuery, RegistriesQueryVariables>(
		RegistriesDocument,
		options
	);
}
export function useRegistriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<RegistriesQuery, RegistriesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<RegistriesQuery, RegistriesQueryVariables>(
		RegistriesDocument,
		options
	);
}
export type RegistriesQueryHookResult = ReturnType<typeof useRegistriesQuery>;
export type RegistriesLazyQueryHookResult = ReturnType<typeof useRegistriesLazyQuery>;
export type RegistriesSuspenseQueryHookResult = ReturnType<typeof useRegistriesSuspenseQuery>;
export type RegistriesQueryResult = Apollo.QueryResult<RegistriesQuery, RegistriesQueryVariables>;
export function refetchRegistriesQuery(variables?: RegistriesQueryVariables) {
	return { query: RegistriesDocument, variables: variables };
}
